import { useEffect, useState } from "react";
import { post } from "../../core/client";
import Box from "@mui/material/Box";
import { CustomButton } from "../../components/buttons";
import DatePicker from '../../components/inputs/date-picker';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Select from "../../components/inputs/select";
import { Grid } from "@mui/material";
import { IsNullOrEmpty, IsNullOrZero } from "../../core/utility";

interface CreateMvkReservationProps {
    memberId: number;
    disabledMonths: Set<string> | undefined;
    onCreated: (created: boolean) => void;
}

interface CreateMvkReservationRequest {
    memberId: number;
    reservationDate: string;
}

interface CreateMvkReservationResponse {
    success: boolean | undefined;
}

const initialReqState: CreateMvkReservationRequest = {
    memberId: 0,
    reservationDate: ""
}

const initialResState: CreateMvkReservationResponse = {
    success: undefined
}

const CreateMvkReservationComponent = (request: CreateMvkReservationProps) => {

    const [requestState, setRequestState] = useState<CreateMvkReservationRequest>(initialReqState);
    const [responseState, setResponseState] = useState<CreateMvkReservationResponse>(initialResState);
    const [loading, setLoading] = useState(false);
    const [errorText, setErrorText] = useState<string>('');
    const [selectedDate, setSelectedDate] = useState<string>("");
    const [selectedTime, setSelectedTime] = useState<number | null>(null);

    const dayjs = require('dayjs');
    var customParseFormat = require("dayjs/plugin/customParseFormat");
    dayjs.extend(customParseFormat);
    const maxDate = dayjs().add(2, "month").endOf("month");

    const reservationTimeData: any = [
        { Name: '9-11', Id: 1, startHour: 9 },
        { Name: '11-15', Id: 2, startHour: 11 },
        { Name: '15-19', Id: 3, startHour: 15 },
        { Name: '19-21.30', Id: 4, startHour: 19 },
    ];

    useEffect(() => {
        setRequestState(prevState => ({
            ...prevState,
            memberId: request.memberId
        }));
    }, []);

    useEffect(() => {
        if(!IsNullOrZero(selectedTime)) {
            handleMergeDateTime();
        }
    }, [selectedTime, selectedDate]);

    const handleRequestChange = (e: any) => {
        setRequestState(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const handleRequestDateChange = (e: any) => {
        setSelectedDate(e.target.value);
    };

    const handleRequestTimeChange = (e: any) => {
        setSelectedTime(e.target.value);
    };

    const handleIsDateDisabled = () => {
        const date = dayjs(requestState.reservationDate, "DD.MM.YYYY", false);
        const inDisabledMonths = request.disabledMonths ? request.disabledMonths.has(date.format("MM.YYYY")) : false;
        return inDisabledMonths;
    }

    const handleCreateReservation = async () => {
        if (!validate()) return;
        setLoading(true);
        const response = await post<CreateMvkReservationResponse>('api/external/create-mvk-reservation', requestState);
        if (response && response.success !== false) {
            setErrorText("");
            setResponseState(response);
            request.onCreated(true);
        } else {
            setErrorText("Bir hata oluştu: Rezervasyon işlemi tamamlanamadı");
        }
        setLoading(false);
    }

    const handleMergeDateTime = () => {
        const hour = reservationTimeData[selectedTime!-1].startHour;
        const date = dayjs(selectedDate, "DD.MM.YYYY", false).hour(hour).minute(0);
        setRequestState(prevState => ({
            ...prevState,
            reservationDate: date,
        }));
    }

    const validate = () => {
        setErrorText("");
        const date = dayjs(requestState.reservationDate, "DD.MM.YYYY HH:mm", false);
        if (!date.isValid() || !date.isAfter(dayjs().subtract(1, "day"), "day") || handleIsDateDisabled()) {
            setErrorText("Geçerli bir tarih giriniz");
            return false
        }
        if (IsNullOrZero(selectedTime) || dayjs() > date) {
            setErrorText("Geçerli bir saat aralığı giriniz");
            return false
        }

        return true
    }

    return (
        <Card className={'member-card'} variant="outlined">
            <CardContent>
                <Typography gutterBottom component="h3">
                    Rezervasyon Kaydı
                </Typography>
                <Divider />
                <Grid container spacing={2} paddingTop={1} paddingBottom={1}>
                    <Grid item xs={8}>
                        <DatePicker
                            id="reservationDate"
                            caption="Rezervasyon Tarihi"
                            name="reservationDate"
                            value={selectedDate}
                            onChange={handleRequestDateChange}
                            disablePast
                            maxDate={maxDate}
                            shouldDisableMonth={request.disabledMonths} />
                    </Grid>
                    <Grid item xs={4}>
                        <Select
                            id="reservationTime"
                            name="reservationTime"
                            onChange={handleRequestTimeChange}
                            caption="Rezervasyon Saati"
                            className="densed-select"
                            disabled={IsNullOrEmpty(selectedDate)}
                            options={{
                                data: reservationTimeData,
                                displayField: 'Name',
                                displayValue: 'Id',
                                selected: selectedTime,
                            }}
                        />
                    </Grid>
                </Grid>
                <Box py={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CustomButton
                        text="REZERVASYONU TAMAMLA"
                        className='btn-primary mr-2'
                        disabled={loading || handleIsDateDisabled()}
                        loading={loading}
                        onClick={async () => await handleCreateReservation()}
                    />
                </Box>
                {errorText !== '' &&
                    <Box py={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="subtitle1" display="block">{errorText}</Typography>
                    </Box>}

                {responseState.success === true &&
                    <Box py={1} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="subtitle1" display="block">Rezervasyon işlemi başarıyla tamamlandı</Typography>
                    </Box>}
            </CardContent>
        </Card>
    );
}

export default CreateMvkReservationComponent;